import { render } from "./EventStatistics.vue?vue&type=template&id=0062ce56&scoped=true"
import script from "./EventStatistics.vue?vue&type=script&lang=js"
export * from "./EventStatistics.vue?vue&type=script&lang=js"

import "./EventStatistics.vue?vue&type=style&index=0&id=0062ce56&scoped=true&lang=scss"
import "./EventStatistics.vue?vue&type=style&index=1&id=0062ce56&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0062ce56"]])

export default __exports__